import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Önizleme ortamı tespiti: bazı bölümler (ör. İl Dışı Mutabakat) yalnız önizlemede görünür, canlıda gizlenir.
export const IS_PREVIEW = (() => {
  try {
    const h = (typeof window !== "undefined" && window.location && window.location.hostname) || "";
    if (h.includes(".preview.emergentagent.com") || h === "localhost" || h.startsWith("127.")) return true;
    const b = process.env.REACT_APP_BACKEND_URL || "";
    return b.includes("preview.emergentagent") || b.includes("localhost");
  } catch (e) {
    return false;
  }
})();

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Sliding session: 401 olduğunda access token'ı sessizce yenile ve isteği tekrarla.
let refreshPromise = null;
const SKIP_REFRESH = ["/auth/login", "/auth/refresh", "/auth/logout"];

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;
    const url = original?.url || "";
    const skip = SKIP_REFRESH.some((p) => url.includes(p));
    if (status === 401 && original && !original._retry && !skip) {
      original._retry = true;
      try {
        if (!refreshPromise) {
          refreshPromise = api.post("/auth/refresh").finally(() => { refreshPromise = null; });
        }
        await refreshPromise;
        return api(original);
      } catch (e) {
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export { API };
